export const formatNumber = (num: number) => {
  // カンマ区切りにする
  return num.toLocaleString();
};

export const formatNumberForInt = (num: number) => {
  // カンマ区切りにする
  return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};
